/**
 * 업로드 직후 「NAS 에도 보관됐는지」를 한 줄로 알려 준다 (v2.96.0 · 2026-08-26).
 *
 * 사용자 결정(2026-08-26): 업로드 버튼을 누르면 **NAS 까지 끝내고 결과를 알려 준다.**
 *
 * 역할 나눔
 *   · 실패 알림(창)  = attachment-api.uploadAttachment 가 한 곳에서 띄운다(통로 8곳을 한 번에 덮는다)
 *   · 성공 표시(이 줄) = 눌러 본 화면에서만. 창을 띄우면 매번 확인을 눌러야 해서 방해가 된다.
 *
 * ⚠ 표 안에서 쓰지 말 것 — 세로로 한 줄이 늘어나 칸 높이가 흔들린다. 첨부 상자 안쪽 전용.
 */

import type { NasAutoSaveResult } from '../lib/attachment-api';

export function NasSaveNotice({ nas }: { nas: NasAutoSaveResult | null | undefined }) {
  // 대상이 아니면(구입견적서 등) 아무 것도 보이지 않는다 — 없는 기능을 있는 것처럼 말하지 않는다
  if (!nas || !nas.attempted) return null;

  if (nas.saved) {
    return (
      <p className="mt-1.5 text-xs text-emerald-700 truncate" title={nas.path ?? undefined}>
        💾 NAS 에도 보관했습니다 — {nas.path ?? ''}
      </p>
    );
  }
  return (
    <p className="mt-1.5 text-xs text-amber-700">
      ⚠ NAS 보관은 하지 못했습니다 — {nas.reason ?? '알 수 없는 이유'}
    </p>
  );
}
